import _classCallCheck from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export function sendNotification(message) {
  _provider.showNotification(message);
}
export var DefaultProvider =
/*#__PURE__*/
function () {
  function DefaultProvider() {
    _classCallCheck(this, DefaultProvider);
  }

  _createClass(DefaultProvider, [{
    key: "showNotification",
    value: function showNotification(message) {
      console.log(message);
    }
  }]);

  return DefaultProvider;
}();

var _provider = new DefaultProvider();

export function init(provider) {
  _provider = provider;
}